export default __webpack_public_path__ + "static/media/casal_1.4f705c7b.jpg";